import { useState, useEffect } from 'react';

export const useIsSmallScreen = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia('(max-width: 640px)').matches;
    }
    return false;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 640px)');
    
    if (mediaQuery.matches !== isSmallScreen) {
      setIsSmallScreen(mediaQuery.matches);
    }

    const handler = (e: MediaQueryListEvent) => setIsSmallScreen(e.matches);
    
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return isSmallScreen;
};